import { TEXT_NUMBER_TYPE } from "@visactor/vrender-core";

export class DefaultMathTextPicker {
    constructor() {
        this.type = "text", this.numberType = TEXT_NUMBER_TYPE;
    }
    contains(text, point, params) {
        return !!text.AABBBounds.containsPoint(point);
    }
}
//# sourceMappingURL=text-picker.js.map
